module.exports = __webpack_public_path__ + "static/media/New Arrival.73b8b178.png";